"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAccessStatusCustomStrategy = void 0;
var error_response_1 = require("../error-response");
var privateCheckAccessCustomMethod;
var setCustomMethod = function (method) {
    privateCheckAccessCustomMethod = method;
};
var execute = function (request) {
    console.log("Executing custom check access status strategy");
    return privateCheckAccessCustomMethod
        ? privateCheckAccessCustomMethod(request)
        : Promise.reject(error_response_1.authSuiteErrorFactory.createError(error_response_1.MethodErrorResponse.CHECK_ACCESS_STATUS));
};
exports.checkAccessStatusCustomStrategy = {
    execute: execute,
    setCustomMethod: setCustomMethod,
};
